import React from 'react';

const Loading = () => (<div><i className="fa fa-spinner fa-spin" /></div>);

export default Loading;



// WEBPACK FOOTER //
// ./src/components/Loading.jsx